import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import useUpdateUserMessagePreferences from "../../hooks/Users/useUpdateArchivedUserChats";
import { useIntl } from "react-intl";
import globalMessages from "../../messages";
import chatMessages from './messages';
import { Chat } from "myfitworld-model/src";
import { useUserProvider } from "src/providers/UserProvider";

export interface ChatPreferenceOptionsProps{
  id: string,
  label:string,
  title:string,
  dialogText: string,
  onHandleAction:(updateUserMessagePreferences: any, chat: Chat, userId: string) => void,
  selectedChatId?: string,
  selectedUserId?:string,
  selectedUserName?:string,
}

const PreferenceChatDialog = ({isOpen, handleClose, chat, chatPreferenceOptions, fetchAllChats}:{
    isOpen:boolean, 
    handleClose:()=>void;
    chat: Chat|undefined;
    chatPreferenceOptions: ChatPreferenceOptionsProps,
    fetchAllChats: () => any;
}) => {
  const {formatMessage} = useIntl();
  const {user} = useUserProvider();
  const {updateUserMessagePreferences: updateFunction} = useUpdateUserMessagePreferences({fetchAllChats});

  return (
    <Dialog
      aria-labelledby="chat-dialog"
      open={isOpen}
      maxWidth="xs"
      fullWidth
      onClick={(event) => {event.stopPropagation(); }}
    >
      <DialogTitle>{formatMessage((chatMessages as any)[chatPreferenceOptions.title])} : <b>{chatPreferenceOptions.selectedUserName}</b></DialogTitle> 
      <DialogContent>
        {formatMessage((chatMessages as any)[chatPreferenceOptions.dialogText])}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
        >
          {formatMessage(globalMessages.cancel)}
        </Button>
        <Button onClick={async () => 
          {
            if(user && user.id && chat) {
              chatPreferenceOptions.onHandleAction(updateFunction, chat, user.id);
            }
            handleClose();
          }}
        >
          {formatMessage(globalMessages.confirmed)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreferenceChatDialog;
